import script from "./AppLockOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLockOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./AppLockOverlay.vue?vue&type=style&index=0&id=7a7a418c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a7a418c"]])

export default __exports__